

















import { Component, Vue, Prop } from 'vue-property-decorator'
import StartButton from '@/components/StartButton.vue'
import InstructionsButton from '@/components/InstructionsButton.vue'
import LanguageSelector from '@/components/LanguageSelector.vue'

@Component({
  components: {
    StartButton,
    InstructionsButton,
    LanguageSelector
  }
})
export default class MainView extends Vue {}
